/*
  ps-specs-datenblatt.js - gehoert zu sections/product-specs.liquid

  1. Variante gewechselt -> Datenblatt dieser Variante nachladen.
     Beim Umschalten tauscht product-info.js nur Preis, Bilder und ein paar
     Felder im Kaufbereich aus. Das Datenblatt ist eine eigene Section und
     blieb stehen: wer von 50 x 120 auf 60 x 180 umschaltete, sah weiter
     "708 Watt" und "50 x 120 cm", bis er die Seite neu lud. Jetzt holt dieses
     Skript die Section fuer die neue Variante ueber die Section Rendering
     API und tauscht nur den Inhalt des Datenblatt-Reiters (`[data-ps-datenblatt]`)
     aus - Reiterleiste und Faltfelder auf dem Handy bleiben unberuehrt.

     Gehoert wird auf das `variant-change`-Ereignis des Themes. Das Ereignis
     `variant:changed` am document traegt in product-info.js noch die alte
     Variante, deshalb nicht das. Ein Schnellkauf-Fenster eines anderen
     Produkts loest dasselbe Ereignis aus; dafuer der Abgleich der Produkt-ID.

  2. Dateigroesse des PDF nachtragen, wenn Liquid sie nicht kennt.
     `generic_file` hat in Liquid kein Groessenfeld. Ist
     `custom.datenblatt_pdf_groesse` nicht gepflegt, fragt ein HEAD-Aufruf
     nach Content-Length. Scheitert der (CORS, kein Header), bleibt die
     Angabe einfach weg.
*/
(() => {
  if (window.psSpecsDatenblatt) return;
  window.psSpecsDatenblatt = true;

  const laufend = new WeakMap();

  const groesseText = (bytes) => {
    if (bytes >= 1048576) {
      return (bytes / 1048576).toLocaleString('de-DE', { maximumFractionDigits: 1 }) + ' MB';
    }
    return Math.max(1, Math.round(bytes / 1024)) + ' KB';
  };

  const groesseNachtragen = (bereich) => {
    bereich.querySelectorAll('[data-ps-pdf]').forEach((link) => {
      const ziel = link.querySelector('[data-ps-pdf-groesse]');
      if (!ziel || ziel.textContent.trim() !== '' || ziel.dataset.psGefragt) return;
      ziel.dataset.psGefragt = '1';
      fetch(link.href, { method: 'HEAD' })
        .then((antwort) => {
          const bytes = Number(antwort.headers.get('content-length'));
          if (antwort.ok && bytes > 0) ziel.textContent = ' · ' + groesseText(bytes);
        })
        .catch(() => {});
    });
  };

  const neuLaden = (wurzel, varianteId) => {
    const id = String(varianteId);
    if (wurzel.dataset.psVariante === id) return;
    wurzel.dataset.psVariante = id;

    const vorher = laufend.get(wurzel);
    if (vorher) vorher.abort();
    const abbruch = new AbortController();
    laufend.set(wurzel, abbruch);

    const url =
      wurzel.dataset.psUrl +
      '?variant=' + encodeURIComponent(id) +
      '&section_id=' + encodeURIComponent(wurzel.dataset.psSektion);

    fetch(url, { signal: abbruch.signal })
      .then((antwort) => (antwort.ok ? antwort.text() : Promise.reject(antwort.status)))
      .then((text) => {
        const neu = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-ps-datenblatt]');
        const alt = wurzel.querySelector('[data-ps-datenblatt]');
        if (!neu || !alt) return;
        if (neu.innerHTML !== alt.innerHTML) alt.innerHTML = neu.innerHTML;
        groesseNachtragen(alt);
      })
      .catch(() => {
        // Fehlgeschlagen: alter Stand bleibt stehen, beim naechsten Wechsel neu versuchen.
        if (wurzel.dataset.psVariante === id) delete wurzel.dataset.psVariante;
      });
  };

  const aufVariante = (varianteId, sektionId) => {
    if (!varianteId || !sektionId) return;
    const info = document.getElementById('MainProduct-' + sektionId);
    const produktId = info && info.dataset.productId;
    if (!produktId) return;
    document.querySelectorAll('.ps-specs[data-ps-produkt]').forEach((wurzel) => {
      if (wurzel.dataset.psProdukt === String(produktId)) neuLaden(wurzel, varianteId);
    });
  };

  const anmelden = () => {
    const pubsub = window.FoxTheme && window.FoxTheme.pubsub;
    if (!pubsub || !pubsub.PUB_SUB_EVENTS) return false;
    pubsub.subscribe(pubsub.PUB_SUB_EVENTS.variantChange, (ereignis) => {
      const daten = ereignis && ereignis.data;
      if (daten && daten.variant) aufVariante(daten.variant.id, daten.sectionId);
    });
    return true;
  };

  const start = () => {
    document.querySelectorAll('.ps-specs').forEach(groesseNachtragen);
  };

  if (!anmelden()) document.addEventListener('DOMContentLoaded', anmelden, { once: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', (ereignis) => {
    if (ereignis.target) groesseNachtragen(ereignis.target);
  });
})();
